import TimeLag from 'utilities/timelag';
import { api } from 'apps/api';
export default class ReadController{
  private static _instance:ReadController;
  current_ids: Array<string>;
  lag: TimeLag;
  public static getInstance():ReadController{
    if (!this._instance){
      this._instance = new ReadController(ReadController.getInstance);
    }
    return this._instance;
  }
  init(){
    this.current_ids = [];
    this.lag = new TimeLag((params)=>{this.connect(params);}, 2000);
  }
  constructor(caller:Function) {
    if (caller == ReadController.getInstance){
      this.init();
    } else if (ReadController._instance){
      throw new Error("既にインスタンスが存在するためエラー。");
    } else {
      throw new Error("コンストラクタの引数が不正な為エラー。");
    }
  }
  onRead(notification_ids){
    for(let i=0;i<notification_ids.length;i++){
      let id = notification_ids[i];
      this.current_ids.push(id);
    }
    this.lag.start(this.current_ids);
  }
  connect(ids){
    this.current_ids = [];
    let payload = {
      url: '/notifications',
      at: App.authenticity_token(),
      params: {ids: ids}
    }
    api.patch(payload)
      .then((data) => {this.onResponse(data)})
      .catch((error) => {console.log(error);});
  }
  onResponse(data){
    let newVal = data.data;
    App.store.dispatch(App.actions.data.update(newVal));
  }
}
